import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import '../users/userform.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../services/AxiosInstance";
import { FiArrowLeft } from 'react-icons/fi';
import InternalFooter from '../components/InternalFooter/InternalFooter';

const AddDesignation = () => {
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: ""   
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Helper function to safely navigate back, avoiding login page
  const navigateBackSafely = () => {
    // Simple approach: try navigate(-1) and if it goes to login, redirect to project list
    navigate(-1);

    // Set a timeout to check if we ended up on login page
    setTimeout(() => {
      if (window.location.pathname.includes('/login')) {
        const search = searchParams.get('search') || '';
        navigate(`/task/projectlist${search ? `?search=${encodeURIComponent(search)}` : ''}`);
      }
    }, 100);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Designation name is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!validate()) return;

    setLoading(true);
    setIsSubmitting(true);

    const userData = JSON.parse(localStorage.getItem("user"));
    
    const payload = {
      name: formData.name,
      corporate_id: userData.corporateId,
    };
    
    try {
      const response = await axiosInstance.post(`/settings/addDesignation`, JSON.stringify(payload));

      if (!response) {
        throw new Error('Failed to submit the form');
      }

      const result = response;
      console.log('Form submitted successfully:', result);
      notifyTopRight('✅ Designation created successfully!');
      
      setTimeout(() => {
        setIsSubmitting(false);
        navigateBackSafely();
      }, 2000);

    } catch (error) {
      console.error('Submission error:', error);
      if (error.status === 409) {
        notifyError('Designation already exists');
      } else {
        notifyError(error.response?.data?.error || 'Failed to create designation');
      }
      setIsSubmitting(false);
    } finally {
      setLoading(false);
    }
  };

 

  const notifyTopRight = (data) => {
    toast.success(`✔️ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const notifyError = (data) => {
    toast.error(`❌ ${data}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <div>
      <button
        className="back-button"
        onClick={() => {
          if (window.history.length > 2) {
            navigate(-1);
          } else {
            navigate('/settings/branchlist');
          }
        }}
      >
        <FiArrowLeft style={{ marginRight: '0.5rem' }} />
        Back
      </button>
      <div className="row" style={{ marginBottom: '0px !important' }}>
        <ToastContainer />
        <div className="col-xl-12 col-xxl-12">
          <div className="card">
          <div className="card-body">
              <section>
                <div className="row">
                
                  <div className="col-lg-6 mb-2">
                    <div className="form-group mb-3">
                      <label className="text-label">Designation Name*</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Enter designation name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && <div className="text-danger">{errors.name}</div>}
                    </div>
                  </div>

                  <div className="text-end toolbar toolbar-bottom p-2">
                    <button 
                      type="button"
                      className="btn btn-cancel me-2" 
                      onClick={navigateBackSafely}
                      disabled={isSubmitting}
                    >
                      Cancel
                    </button>
                    <button 
                      className="btn user-form-btn sw-btn-next" 
                      onClick={handleSubmit} 
                      disabled={isSubmitting} 
                      style={{ maxWidth: '100px' }}
                    >
                      {loading ? (
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      ) : null}
                      Submit
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <InternalFooter />
      </div>
    </div>
  );
};

export default AddDesignation;